import styled from 'styled-components'

import { login } from '../../styles/z-index'
import { minmedia } from '../../styles/media-queries'
import { white, bordergray, red } from '../../styles/colors'

export const Container = styled.div`
  width: 100%;
  max-width: calc(100% - 4rem);
  box-sizing: border-box;
  border-radius: 0.25rem;
  z-index: ${login}; //appear above overlay
  position: relative;
  ${minmedia.medium`
    max-width: 300px;
  `} ${minmedia.large`
    max-width: 440px;
    background: ${white};
  `};
`

export const Feedback = styled.div`
  margin-bottom: 1rem;
  margin-top: -0.5rem;
  color: ${red};
  font-size: 14px;
  width: 100%;
  text-align: center;
`

export const IconContainer = styled.div`
  max-width: 250px;
  margin: 0 auto;
  margin-bottom: 2rem;
`

export const LoginContainer = styled.div`
  ${minmedia.large`
    padding: 2rem;
  `};
`

export const Header = styled.h2`
  display: none;
  text-align: center;
  margin: 0;
  font-size: 36px;
  padding: 1.5rem;
  border-bottom: 1px solid ${bordergray};
  width: 100%;

  ${minmedia.large`
    display: block;
  `};
`




// WEBPACK FOOTER //
// ./src/containers/OCIForm/styles.js